// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/radio-group","root":"radio-group-m__root__3OlYp","legend":"radio-group-m__legend__1Ewcn label-m__root__2OcvT mdc-textfield__mdc-floating-label__1r8KC"};